import { useState } from "react";
import ChargerWalletCheque from "./ChargerWalletPayements/ChargerWalletCheque";
import ChargerWalletEspece from "./ChargerWalletPayements/ChargerWalletEspece";
import ChargerWalletVirement from "./ChargerWalletPayements/ChargerWalletVirement";
import ChargerWalletEnLign from "./ChargerWalletPayements/ChargerWalletEnLign";
import ChargerWalletMultiCheque from "./ChargerWalletPayements/ChargerWalletMultiCheque";




const ChargerWalletFournisseur=()=>{


    const [methodePayement, setMethodePayement] = useState();
    const handleChangePayement = (e) => {
        let payement = e.target.value;
        setMethodePayement(payement);
    };
    const createUIPayement = () => {
        if (methodePayement === "CHEQUE") {
            return <ChargerWalletCheque />;
        } else if (methodePayement === "ESPECE") {
            return <ChargerWalletEspece />
        } else if (methodePayement === "VIREMENT") {
            return <ChargerWalletVirement />;
        } else if (methodePayement === "ENLIGNE") {
            return <ChargerWalletEnLign />;
        }else if (methodePayement === "MULTICHEQUE") {
            return <ChargerWalletMultiCheque />;
        }
    };



    return (<div className="content-wrapper" style={{ marginTop: "0" }}>
        <br />
        <section class="content">
            <div class="row">
                <div class="col-md-12">
                    <div className="card card-dark">
                        <div className="card-header">
                            <h3 className="card-title">Charger Wallet</h3>
                        </div>
                        <div className="card-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <label>Choisir le mode de payement</label>

                                    <select
                                        class="form-control"
                                        onChange={handleChangePayement}
                                    >
                                        <option key={0} value={0}>
                                            Sélectionner un mode de payement
                                        </option>
                                        <option key={1} value={"ESPECE"}>
                                            Espèce
                                        </option>
                                        <option key={2} value={"ENLIGNE"}>
                                            En ligne
                                        </option>
                                        <option key={3} value={"CHEQUE"}>
                                            Chèques / Traites
                                        </option>
                                        {/* <option key={4} value={"MULTICHEQUE"}>
                                            Multi Chèques / Traites
                                        </option> */}
                                        <option key={5} value={"VIREMENT"}>
                                            Virement
                                        </option>
                                    </select>
                                </div>
                            </div>
                            {createUIPayement()}
                        </div>
                    </div>
                </div>{" "}
            </div>
        </section>
    </div>)




}
export default ChargerWalletFournisseur;